import React from 'react';
import { SkeletonHeadingItem, SkeletonItem } from '@atlaskit/menu';
import { testIdConcat } from '@atlassian/jira-navigation-apps-common/src/utils/test-id.tsx';
import type { MenuSkeletonContentProps } from './types.tsx';

export const MenuSkeletonContent = ({
	testIdPrefix,
}: MenuSkeletonContentProps): React.JSX.Element => (
	<div data-testid={testIdConcat(testIdPrefix, 'skeleton')}>
		<SkeletonHeadingItem />
		<SkeletonItem hasIcon width="62.5%" />
		<SkeletonItem hasIcon width="50%" />
		<SkeletonItem hasIcon width="62.5%" />
		<SkeletonItem hasIcon width="50%" />
	</div>
);
